import { render, staticRenderFns } from "./KnowledgeBaseExplorer.vue?vue&type=template&id=10e0ebbd&scoped=true&"
import script from "./KnowledgeBaseExplorer.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseExplorer.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseExplorer.vue?vue&type=style&index=0&id=10e0ebbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e0ebbd",
  null
  
)

export default component.exports